<template>
  <UiModal
    :model-value="Boolean(state)"
    :title="state?.title ?? ''"
    size="sm"
    @update:model-value="state?.resolve(false)"
  >
    <p v-if="state?.message" class="text-soft">{{ state.message }}</p>

    <template #footer>
      <UiButton variant="secondary" @click="state.resolve(false)">
        {{ state?.cancelLabel }}
      </UiButton>
      <UiButton :variant="state?.danger ? 'danger' : 'primary'" @click="state.resolve(true)">
        {{ state?.confirmLabel }}
      </UiButton>
    </template>
  </UiModal>
</template>

<script setup>
import UiModal from './UiModal.vue'
import UiButton from './UiButton.vue'
import { useConfirm } from '../composables/useConfirm'

const { state } = useConfirm()
</script>
